import { render, staticRenderFns } from "./CustomerReceiveTab.vue?vue&type=template&id=cb99eb18&scoped=true"
import script from "./CustomerReceiveTab.vue?vue&type=script&lang=js"
export * from "./CustomerReceiveTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerReceiveTab.vue?vue&type=style&index=0&id=cb99eb18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb99eb18",
  null
  
)

export default component.exports